import React from 'react'
import ExperiencePage from '../Components/Experience/Experience'
const Experience = () => {
  return (
    <div>
      <ExperiencePage/>
    </div>
  )
}

export default Experience